import React, { FunctionComponent } from 'react';

import { Section as SectionType } from '@gojob/cms';
import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';

import Background from '../Background';
import BannerTitle from '../Section/BannerTitle';
import Breadcrumbs from '../Section/Breadcrumbs';
import EditoLinkList from '../Section/EditoLinkList';
import FootNotes from '../Section/FootNotes';
import HeroPic from '../Section/HeroPic';
import JobSearch from '../Section/JobSearch';
import LogoList from '../Section/LogoList';
import QuoteCarousel from '../Section/QuoteCarousel';
import Sectors from '../Section/Sectors';
import SellingPropositionList from '../Section/SellingPropositionList';
import TSASimulation from '../Section/TSASimulation';
import UserJourney from '../Section/UserJourney';
import Video from '../Section/Video';
import VignetteCarousel from '../Section/VignetteCarousel';
import EditoList from './EditoList/';
import WaitingList from './WaitingList';

export type SectionProps = {
  section?: SectionType;
  title?: string;
};

const Section: FunctionComponent<SectionProps> = (props) => {
  const { title, section } = props;

  const Content = () => {
    switch (section?._type) {
      case 'banner_title':
        return <BannerTitle {...section} />;
      case 'breadcrumbs':
        return <Breadcrumbs title={title} {...section} />;
      case 'edito_link_list':
        return <EditoLinkList {...section} />;
      case 'edito_list':
        return <EditoList {...section} />;
      case 'foot_notes':
        return <FootNotes {...section} />;
      case 'hero_pic':
        return <HeroPic {...section} />;
      case 'logo_list':
        return <LogoList {...section} />;
      case 'quotes':
        return <QuoteCarousel {...section} />;
      case 'sectors':
        return <Sectors {...section} />;
      case 'selling_proposition_list':
        return <SellingPropositionList {...section} />;
      case 'user_journey':
        return <UserJourney {...section} />;
      case 'vignettes':
        return <VignetteCarousel {...section} />;
      case 'tsa_simulation':
        return <TSASimulation href={section.link} />;
      case 'section_video':
        return <Video {...section} />;
      case 'waitinglist':
        return <WaitingList {...section} />;
      default:
        return null;
    }
  };

  if (section?._type === 'job_search') {
    return (
      <PaletteProvider variant="primary">
        <Background>
          <JobSearch {...section} />
        </Background>
      </PaletteProvider>
    );
  }

  return (
    <PaletteProvider variant={section?.variant?.variant}>
      <Background>
        <Content />
      </Background>
    </PaletteProvider>
  );
};

export default Section;
